import { crossBorderPolicyRegex } from 'constants/regex'
import { IFormValues } from './types'
import { CROSS_BORDER_POLICY_FORM_VALUES } from 'texts/termsAndConditions'
import { USA_ID } from 'constants/locations'

export type ErrorState = {
  [key: number]: {
    [key: string]: string
  }
}

const ERROR_MESSAGES = {
  state: CROSS_BORDER_POLICY_FORM_VALUES.AUSTRALIA_STATE.VALIDATION_MESSAGE,
  province: CROSS_BORDER_POLICY_FORM_VALUES.CANADA_STATE.VALIDATION_MESSAGE,
}

const checkValue = (
  value: string,
  fieldName: string,
  id: number,
  onChangeErrors: React.Dispatch<React.SetStateAction<ErrorState>>
) => {
  if (!crossBorderPolicyRegex.test(value)) {
    onChangeErrors((prev: ErrorState) => ({
      [id]: {
        ...prev[id],
        [fieldName]: ERROR_MESSAGES[fieldName as keyof typeof ERROR_MESSAGES],
      },
    }))
    return false
  } else {
    onChangeErrors((prev: ErrorState) => ({
      [id]: { ...prev[id], [fieldName]: '' },
    }))
    return true
  }
}

export const checkStateValues = (
  values: IFormValues,
  onChangeErrors: React.Dispatch<React.SetStateAction<ErrorState>>
) => {
  let isAustraliaStateValid = true
  let isCanadaStateValid = true
  let isUSAStateValid = true
  values.countryIds.forEach(
    ({ state, province, id, usaStateIds, countryList }) => {
      const isUSASelected = !!countryList.find(
        ({ value }) => value === String(USA_ID)
      )

      if (state) {
        isAustraliaStateValid = checkValue(state, 'state', id, onChangeErrors)
      }
      if (province) {
        isCanadaStateValid = checkValue(
          province,
          'province',
          id,
          onChangeErrors
        )
      }
      if (!usaStateIds?.length && isUSASelected) {
        onChangeErrors((prev: ErrorState) => ({
          [id]: {
            ...prev[id],
            usaStateIds:
              CROSS_BORDER_POLICY_FORM_VALUES.STATE_LIST.VALIDATION_MESSAGE,
          },
        }))
        isUSAStateValid = false
      } else {
        onChangeErrors((prev: ErrorState) => ({
          [id]: { ...prev[id], usaStateIds: '' },
        }))
        isUSAStateValid = true
      }
    }
  )

  return isAustraliaStateValid && isCanadaStateValid && isUSAStateValid
}
